export const CardSkeleton = () => (
  <div className="p-4 lg:p-6 border rounded-lg mb-4 animate-pulse">
    <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">
      {/* Logo and Title Section */}
      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex gap-4">
          <div className="h-20 w-20 bg-background rounded-lg shrink-0"></div>
          <div className="flex flex-col gap-2 md:hidden">
            <div className="h-6 w-48 lg:w-64 bg-background rounded"></div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-background rounded-full"></div>
              <div className="h-4 w-32 bg-background rounded"></div>
            </div>
          </div>
        </div>

        {/* Info Section */}
        <div className="flex flex-col gap-6">
          <div className="hidden flex-col gap-2 md:flex">
            <div className="h-6 w-48 lg:w-64 bg-background rounded"></div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-background rounded-full"></div>
              <div className="h-4 w-32 bg-background rounded"></div>
            </div>
          </div>
          <div className="grid grid-cols-3 lg:flex items-center gap-4 lg:gap-12">
            <div className="flex flex-col gap-1">
              <div className="h-4 w-8 bg-background rounded"></div>
              <div className="h-5 w-16 bg-background rounded"></div>
            </div>
            <div className="hidden lg:block h-10 w-[1px] bg-background"></div>
            <div className="flex flex-col gap-1">
              <div className="h-4 w-24 bg-background rounded"></div>
              <div className="h-5 w-12 bg-background rounded"></div>
            </div>
            <div className="hidden lg:block h-10 w-[1px] bg-background"></div>
            <div className="flex flex-col gap-1">
              <div className="h-4 w-16 bg-background rounded"></div>
              <div className="h-5 w-12 bg-background rounded"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Buttons Section - Modified for single row on mobile */}
      <div className="flex items-center gap-2 mt-4 lg:mt-0">
        <div className="h-10 flex-1 w-16 lg:w-32 bg-background rounded-full"></div>
        <div className="h-10 flex-1 w-16 lg:w-32 bg-background rounded-full border"></div>
        <div className="h-10 w-10 bg-background rounded-full border"></div>
        <div className="h-10 w-10 bg-background rounded-full border"></div>
        <div className="h-10 w-10 bg-background rounded-full border"></div>
      </div>
    </div>
  </div>
);

export const HeaderSkeleton = () => (
  <div className="px-4 py-4 animate-pulse">
    <div className="h-8 w-2/3 bg-background rounded mb-4"></div>
    <div className="h-4 w-full bg-background rounded"></div>
  </div>
);

const SearchResultsSkeleton = ({ numberOfCards = 5 }) => (
  <div className="min-h-[calc(100vh-300px)] px-4 lg:px-6">
    {Array(numberOfCards)
      .fill(null)
      .map((_, index) => (
        <CardSkeleton key={index} />
      ))}
  </div>
);

export default SearchResultsSkeleton;
